
import { useHistory, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Card, Row, Col, Label } from "reactstrap";
import Layout from "../../components/Wrappers/Layout";
import val from "../../getThemeDetails";
import constants from "../../config/constants";
import { resetUpdateWalletTransactionStatus } from "../../redux/actions/updateWalletTransactionStatusPartnerAction"
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { resetPartnerGetRefundDetails } from "../../redux/actions/partnerGetRefundDetailsAction";




function WalletManagement() {

	const { t } = useTranslation();
	const history = useHistory();
	const { pathname } = useLocation();
	const dispatch = useDispatch();

	const {
		data: { isMyBankAllowed, isMyWalletAllowed, isMyCardAllowed }
	} = useSelector(({ walletSetting }) => walletSetting);

	const getMappedListRes = useSelector(
		({ getMappedList }) => getMappedList
	);
	const Theme = useSelector((state) => state.theme.theme);
	const options = [
		{
			id: 1,
			// label: "Wallet Dashboard",
			label:"Account Dashboard",
			route: "/index/wallet-dashboard",
			src: `${process.env.PUBLIC_URL}/${Theme}/wallet dashboard.png`,
			flag: "WALLET DASHBOARD",
		},
		{
			id: 2,
			// label: "Wallet Transaction",
			label:"Transaction",
			route: "/index/wallet-transaction",
			src: `${process.env.PUBLIC_URL}/${Theme}/wallet transaction.png`,
			flag: "WALLET TRANSACTION",
		},
		{
			id: 3,
			// label: "My Banks",
			label: "Fee Transaction",
			route: "/index/operation-logs",
			src: `${process.env.PUBLIC_URL}/${Theme}/FEE RECEIVED.png`,
			flag: "OPERATION LOGS",
		},
			{
			id: 4,
			label: "Refund",
			// route: "/index/risk-rules",merchantInvoice
			route: "/index/Refund",
			// route: "/index/merchant-invoice",
			src: `${process.env.PUBLIC_URL}/${Theme}/RECEIVED.png`,
			flag: "REFUND",
		},
		{
			id: 5,
			label: "Fee Report",
			route: "/index/fee-report",
			src: `${process.env.PUBLIC_URL}/${Theme}/fee report.png`,
			flag: "FEE REPORT",
		},
		{
			id: 6,
			label: "Summary Report",
			route: "/index/summary-report",
			src: `${process.env.PUBLIC_URL}/${Theme}/summary report1.png`,
			flag: "SUMMARY REPORT",
		},
		{
			id: 7,
			label: "Loyalty Points",
			route: "/index/loyal-points",
			src: `${process.env.PUBLIC_URL}/${Theme}/loyalty points.png`,
			flag: "LOYALTY POINTS",
		},
			{
			id: 8,
			label: "Settlement Report",
			route: "/index/settlement-report",
			src: `${process.env.PUBLIC_URL}/${Theme}/summary report1.png`,
			flag: "SETTLEMENT REPORT",
		},
			{
			id: 9,
			label: "ChargeBack",
			route: "/index/chargeback",
			src: `${process.env.PUBLIC_URL}/${Theme}/chargeback.png`,
			flag: "CHARGEBACK",
		},
		{
			id: 10,
			label: "Reconciliation",
			route: "/index/reconciliation",
			src: `${process.env.PUBLIC_URL}/${Theme}/reconciliation.png`,
			flag: "RECONCILIATION",
		}

	];

	useEffect(() => {


		dispatch(resetPartnerGetRefundDetails())
		return () => {


			dispatch(resetPartnerGetRefundDetails())
		}
	}, [])

	useEffect(() => {
		dispatch(resetUpdateWalletTransactionStatus())

		// setNotificationRefundOpen(false)

		return (() => {
			// setNotificationRefundOpen(false)
			dispatch(resetUpdateWalletTransactionStatus())

		})
	}, [])

	const filteredOptns = options.filter(({ label }) => {
		// if (
		//   label === "My Cards" && !constants.visibleFlags.includes(isMyCardAllowed)
		// ) {
		//   return label !== "My Cards";
		// }
		// else if (
		//   label === "My Banks" &&  !constants.visibleFlags.includes(isMyBankAllowed)
		// )
		// {
		//   return label !== "My Banks";
		// }
		if (
			label === "My Wallets" &&
			!constants.visibleFlags.includes(isMyWalletAllowed)
		) {
			// return label !== "My Wallets";
		} else return true;
	});
	// .sort((a, b) => {
	//   return a.label > b.label ? 1 : -1;
	// });
	const handleRoute = (route) => {
		history.push({ pathname: route, state: { from: pathname } });
	};


	if (!filteredOptns.length) {
		return (
			<Layout>
				<Card className="mk-root">
					<Row className="mk-row m-auto">No My Accounts Available</Row>
				</Card>
			</Layout>
		);
	}





	return (
		<Layout>
			<Card className="mk-root">
				<Row className="mk-row">
					{options.map(({ id, src, label, route, flag }) => {
						if (
							getMappedListRes.success &&
							getMappedListRes.data.moduleAllocationVO.masterSubModuleMappingList.includes(flag)
						) {
							return (<Col key={id} md={4} sm={4} xs={6}>
								<div className="mk-imageRoot" onClick={() => handleRoute(route)}>
									<div className="mk-imageContainer">
										<img className="mk-image" src={src} alt={label} />
									</div>
									<Label for={label} className="fs-14">
										{t(label)}
									</Label>
								</div>
							</Col>)
						}
					})}
				</Row>
			</Card>
		</Layout>
	);
}

export default WalletManagement;
